module.exports = __webpack_public_path__ + "media/images/employees/zsofi-607b2585b28af927a001c4909084ae50.png";